import { Flex, IconButton, Text, Button, Icon } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconClose, IconTrashbin, IconBan, IconUsers } from 'assets/icons';
import Drawer from 'components/Drawer';
import { FloatingFooter } from 'components/Table';
import MassJobs from 'containers/JobsTasks/RightDrawer/MassJobs';

interface IJobsTableFooter {
  selectedFlatRows: any[];
  toggleAllRowSelected: (value?: boolean) => void;
  handleBulkDeactivate: (value: any[]) => void;
  handleBulkDelete: (value: any[]) => void;
  handleBulkTrackMileage: (value: any[]) => void;
}

const JobsTableFooter: React.FC<IJobsTableFooter> = ({
  selectedFlatRows,
  toggleAllRowSelected,
  handleBulkDeactivate,
  handleBulkDelete,
  handleBulkTrackMileage,
}) => {
  const { t } = useTranslation(['common', 'jobsTasks']);

  const jobsData = selectedFlatRows.map((row: any) => row?.original);

  return (
    <FloatingFooter>
      <Flex alignItems="center">
        <IconButton
          aria-label="Close button"
          icon={<Icon as={IconClose} h="10px" w="10px" />}
          onClick={() => toggleAllRowSelected(false)}
          variant="unstyled"
        />
        <Text>
          ({selectedFlatRows.length}) {t('common:selected')}
        </Text>
      </Flex>
      <Flex gridGap={2}>
        <Button onClick={() => handleBulkTrackMileage(selectedFlatRows)} size="sm" fontSize="sm">
          {t('jobsTasks:trackUntrackMileage')}
        </Button>

        <Drawer
          drawerTrigger={onOpen => (
            <Button
              leftIcon={
                <Icon
                  as={IconUsers}
                  sx={{
                    path: { fill: 'primary.500' },
                  }}
                />
              }
              size="sm"
              variant="ghost"
              bg="primary.50"
              _hover={{ bg: 'primary.100' }}
              onClick={onOpen}
            >
              {t('common:assignTo')}
            </Button>
          )}
        >
          {onClose => <MassJobs onClose={onClose} initialJobs={jobsData} />}
        </Drawer>

        <Button
          leftIcon={
            <Icon
              as={IconBan}
              sx={{
                path: { fill: 'primary.500' },
              }}
            />
          }
          size="sm"
          fontSize="sm"
          variant="ghost"
          bg="primary.50"
          _hover={{ bg: 'primary.100' }}
          onClick={() => handleBulkDeactivate(selectedFlatRows)}
        >
          {t('jobsTasks:deactivateJob')}
        </Button>
        <Button
          leftIcon={
            <Icon
              as={IconTrashbin}
              sx={{
                path: { fill: 'secondary.500' },
              }}
            />
          }
          size="sm"
          fontSize="sm"
          colorScheme="secondary"
          variant="ghost"
          bg="secondary.50"
          _hover={{ bg: 'secondary.100' }}
          onClick={() => handleBulkDelete(selectedFlatRows)}
        >
          {t('jobsTasks:deleteJob')}
        </Button>
      </Flex>
    </FloatingFooter>
  );
};

export default JobsTableFooter;
